import React, { useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import _ from "lodash";
import { getTrans as t } from "../../../Localization/translations";
import ExpenseCategoryService from "../../../services/expenses/expenseCategoryServices";
import jsPDF from "jspdf";
import { autoTable } from "jspdf-autotable";

const ExpenseCategories = ({ customerPermission }) => {
    const tableRef = React.createRef();
    const permissionss = localStorage.getItem("permissions") || "";
    const permissionsArray = permissionss.split(",");
    const navigate = useNavigate();

    const handleEdit = (id) => {
        navigate("/edit-expense-category", { state: id });
    };

    const handleView = (id) => {
        navigate("/view-expense-category", { state: id });
    };

    const handleDelete = (id) => {
        confirmAlert({
            title: "",
            message: "Are you sure you want to delete this category?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        ExpenseCategoryService.deleteCategory(id)
                            .then(() => {
                                toast.success("Category deleted successfully", {
                                    position: "top-right",
                                    autoClose: 1000,
                                    theme: "light",
                                });

                                tableRef.current.onQueryChange(); // refresh table
                            })
                            .catch(() => {
                                toast.error("Failed to delete category", {
                                    position: "top-right",
                                    autoClose: 1000,
                                    theme: "light",
                                });
                            });
                    },
                },
                {
                    label: "No",
                },
            ],
        });
    };



    return (
        <div className="page-wrapper">
            <ToastContainer />
            <div className="content container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <MaterialTable
                            tableRef={tableRef}
                            style={{
                                backgroundColor: "var(--bs-table-bg)",
                                borderBottomWidth: "1px",
                                boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            }}
                            title={<h5 className="d-lg-flex">{t("Expense Categories")}</h5>}
                            columns={[
                                {
                                    title: t("Category ID"),
                                    field: "id",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <div
                                            className="hyperlink"
                                            onClick={() => handleView(rowData.id)}
                                        >
                                            {rowData.id}
                                        </div>
                                    ),
                                },
                                {
                                    title: t("Category Name"),
                                    field: "category_name",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },
                            ]}
                            data={(query) =>
                                new Promise((resolve, reject) => {
                                    ExpenseCategoryService.getCategories(query)
                                        .then((res) => {
                                            const categories =
                                                res.data?.results ||
                                                res.data?.data ||
                                                res.data ||
                                                [];

                                            const total =
                                                res.data?.count ||
                                                res.data?.total ||
                                                categories.length;

                                            // 🔴 FIX: convert backend page → MaterialTable page
                                            const currentPage = res.data?.page
                                                ? res.data.page - 1
                                                : query.page;

                                            resolve({
                                                data: categories,
                                                page: currentPage,
                                                totalCount: total,
                                            });
                                        })
                                        .catch(() => reject());
                                })
                            }



                            localization={{
                                toolbar: { searchPlaceholder: "Search Expense Category" },
                            }}
                            actions={[
                                {
                                    icon: () => (
                                        <img
                                            src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
                                            alt="edit"
                                            style={{ cursor: "pointer" }}
                                        />
                                    ),
                                    tooltip: "Edit",
                                    onClick: (event, rowData) => {
                                        navigate(`/expense-categories/edit/${rowData.id}`);
                                    },
                                },
                                {
                                    icon: () => (
                                        <img
                                            src={process.env.PUBLIC_URL + "/static/images/ic-delete.svg"}
                                            alt="delete"
                                            style={{ cursor: "pointer" }}
                                        />
                                    ),
                                    tooltip: "Delete",
                                    onClick: (event, rowData) => {
                                        handleDelete(rowData.id);
                                    },
                                },
                            ]}

                            components={{
                                Toolbar: (props) => (
                                    <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                                        <MTableToolbar {...props} />

                                        <Link
                                            className="navbar-brand m-0"
                                            to="/expense-categories/add">
                                            <button
                                                className="add-party add btn btn-primary  mb-0"
                                                id="add-task"
                                            >
                                                +&nbsp; {t("Add Category")}
                                            </button>
                                        </Link>

                                    </div>
                                ),
                            }}
                            options={{
                                headerStyle: {
                                    backgroundColor: "white",
                                    color: "#245C7F",
                                    fontSize: 11,
                                },
                                rowStyle: (rowData, index) => {
                                    if (index % 2) {
                                        return { backgroundColor: "#fff" };
                                    }
                                },
                                sorting: true,
                                search: true,
                                toolbar: true,
                                paging: true,
                                pageSize: 10, 
                                emptyRowsWhenPaging: false, 
                                pageSizeOptions: [10, 20, 25, 50],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                actionsColumnIndex: -1
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExpenseCategories;
